import { createContext, useState, useEffect } from "react";

const AuthContext = createContext({});

export const AuthProvider = ({ children }) => {
  const storedAuth = JSON?.parse(localStorage?.getItem("auth")) || {};
  const [auth, setAuth] = useState(storedAuth);

  useEffect(() => {
    localStorage?.setItem("auth", JSON?.stringify(auth));
  }, [auth]);

  useEffect(() => {
    const sessionMarker = sessionStorage?.getItem("sessionExists");

    if (!sessionMarker) {
      // If no session marker exists → New tab opened → Log out
      localStorage?.removeItem("auth");
      sessionStorage?.setItem("sessionExists", "true"); // Mark session active
      window?.location?.reload();
    }
  }, []);

  return (
    <AuthContext.Provider value={{ auth, setAuth }}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContext;
